export default __webpack_public_path__ + "static/media/cta-livestream.c650cbe5.png";